import React from 'react';
import Navbar from '../components/nav/Navbar';
import Footer from '../components/nav/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950 text-zinc-100">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-8 py-24 space-y-12 relative z-10">
        <div className="space-y-4">
          <span className="text-xs font-black tracking-widest text-brand-pink uppercase">Legal</span>
          <h1 className="text-5xl font-black tracking-tighter text-white uppercase">Terms of Service</h1>
          <p className="text-zinc-500 font-bold uppercase tracking-widest text-xs">Last Updated: October 24, 2026</p>
        </div>
        
        <div className="space-y-8 text-zinc-300 text-lg leading-relaxed glass-panel p-8 md:p-12 rounded-3xl">
          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">1. Acceptance of Terms</h2>
            <p>By accessing and using Vision Direct, you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">2. Description of Service</h2>
            <p>Vision Direct provides users with access to a rich collection of resources, including various communications tools, forums, shopping services, and personalized content. You also understand and agree that the service may include advertisements and that these advertisements are necessary for Vision Direct to provide the service.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">3. User Conduct</h2>
            <p>You understand that all information, data, text, software, music, sound, photographs, graphics, video, messages or other materials, whether publicly posted or privately transmitted, are the sole responsibility of the person from which such content originated. This means that you, and not Vision Direct, are entirely responsible for all content that you upload, post, email, transmit or otherwise make available via the service.</p>
          </section>

          <section className="space-y-4">
            <h2 className="text-2xl font-black text-white uppercase tracking-tight">4. Modifications to Service</h2>
            <p>Vision Direct reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, the service (or any part thereof) with or without notice. You agree that Vision Direct shall not be liable to you or to any third party for any modification, suspension or discontinuance of the service.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;